import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getOwnerChargers } from "../pages/api/api"

const initialState = {
  chargers: [],
  status: "idle",
  error: null,
}

// fetch chargers thunk
export const fetchChargers = createAsyncThunk("chargers/fetchChargers", async (_, thunkAPI) => {
  try {
    const response = await getOwnerChargers()
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.message)
  }
})

const chargersSlice = createSlice({
  name: "chargers",
  initialState,
  reducers: {
    setChargersState: (state, action) => {
      state.chargers = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChargers.pending, (state) => {
        state.status = "loading"
      })
      .addCase(fetchChargers.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.chargers = action.payload
      })
      .addCase(fetchChargers.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const {setChargersState} = chargersSlice.actions
export default chargersSlice.reducer
